import React from "react";
import cx from "classnames";
import { ReactComponent as Discount } from "icons/discount-circle.svg";

type Props = {
  placeholder: string;
  value: string;
  placeholderStyle?: any;
  label?: string;
  labelStyle?: any;
  type?: string;
  isHelp?: boolean;
  helpText?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const CouponInputAuth: React.FC<Props> = ({
  placeholder,
  placeholderStyle,
  label,
  labelStyle,
  helpText,
  isHelp,
  className,
  value,
  onChange,
  onBlur,
}): JSX.Element => {
  return (
    <div className={cx("flex flex-col min-w-0", className)}>
      {label && (
        <span
          className="font-sora text-sm"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: "#A5A5A5",
          }}
        >
          {label}
        </span>
      )}
      <div
        className={cx(
          "flex flex-row w-full mr-3 h-14 text-sm justify-between",
          isHelp ? "border-bt-red my-1" : "my-2",
          placeholderStyle
        )}
        style={{
          background: "#FFFFFF",
          border: isHelp ? "2px solid #FD5B28" : "0.5px solid #8E8E8E",
          borderRadius: "4px",
        }}
      >
        <div className="flex flex-col">
          <input
            className="w-full ml-2 my-auto border-none focus:border-transparent focus:ring-0"
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            autoComplete="off"
          />
        </div>
        <div className="flex flex-col mr-3 my-auto">
          <Discount />
        </div>
      </div>
      {isHelp && helpText && (
        <div className="flex flex-row">
          <span className="font-nunito mt-1 text-xs text-bt-red">
            {helpText}
          </span>
        </div>
      )}
    </div>
  );
};

export default CouponInputAuth;
